export default __webpack_public_path__ + "static/media/021-hand mirror.9339090d.svg";